import React, { useEffect, useState } from 'react'
import facebook from '../../Assests/ee50e467241a4a5b1469e6fbe4e1491df7da03c8.png'
import x from '../../Assests/974b66e5853edd33915dc8029fc05fe5be2813ed.png'
import instagram from '../../Assests/f0bd89e1043fabacc3dc40272d80b0bc2bddbf4a.png'
import arrowImage from '../../Assests/location-1093169_1920.png'
import lightBg from '../../Assests/125e006a2387f86ed5e799536ebfd1d28b393975.png'
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './Contact.css'
import { urlApiServer } from '../../Config/Config'
import linkeding from '../../Assests/social.png'

function Contact() {

    const urlPostContacts = `${urlApiServer}contact-me-forms`;
    const urlGetContacts = `${urlApiServer}cover-contact-mes?populate=*`
    const urlGetContactDetail = `${urlApiServer}company-details?populate=*`

    const [countryCodes, setCountryCodes] = useState([]);
    const [locationCoordinates, setLocationCoordinates] = useState([10.9771629, -74.8131299]); // Coordenadas iniciales
    const [first_name, setFirst_name] = useState('')
    const [last_name, setLast_name] = useState('')
    const [email, setEmail] = useState('')
    const [prefixNumber, setPrefixNumber] = useState('+1')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState('')
    const [data, setData] = useState([]); // This is already correct in your code
    const [dataInformation, setDataInformation] = useState([]);

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetContactDetail, requestOptions)
                    .then(response => response.json())
                    .then(ContactResponse => {
                        console.log('info del Contact: ', ContactResponse.data);

                        // Asegurar que siempre sea un array
                        setDataInformation(Array.isArray(ContactResponse.data) ? ContactResponse.data : []);

                        if (ContactResponse.data && ContactResponse.data.length > 0 && ContactResponse.data[0].localizacion) {
                            getCoordinatesFromAddress(ContactResponse.data[0].localizacion);
                        }
                    });
            } catch (error) {
                console.log('el backend esta temporalmente desactivado');
                setDataInformation([]); // Asegurar que sea un array vacío en caso de error
            }
        })();
    }, [urlGetContactDetail]);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetContacts, requestOptions)
                    .then(response => response.json())
                    .then(ContactResponse => {
                        console.log('info del Contact: ', ContactResponse.data);
                        // Asegurar que siempre sea un array
                        setData(Array.isArray(ContactResponse.data) ? ContactResponse.data : []);
                    });
            } catch (error) {
                console.log('el backend de la informacion de introduccion esta temporalmente descativado');
                setData([]); // Asegurar que sea un array vacío en caso de error
            }

        })();

    }, [urlGetContacts]);

    useEffect(() => {
        const fetchCountryCodes = async () => {
            try {
                const response = await fetch("https://countriesnow.space/api/v0.1/countries/codes");
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();

                const codes = data.data
                    .map(item => `+${item.dial_code.replace(/\+/g, "")}`)
                    .filter(code => code && code.length > 1);

                const sortedCodes = [...new Set(codes)].sort((a, b) => a.localeCompare(b));

                console.log('sortedCodes: ', sortedCodes);

                setCountryCodes(sortedCodes);

                // Establecer prefijo por defecto
                if (sortedCodes.includes("+1")) {
                    setPrefixNumber("+1");
                } else if (sortedCodes.length > 0) {
                    setPrefixNumber(sortedCodes[0]);
                }
            } catch (error) {
                console.error("Error fetching country codes:", error);
                setCountryCodes(["+1", "+44", "+52", "+57", "+34"]);
                setPrefixNumber("+1");
            }
        };

        fetchCountryCodes();
    }, []);

    const arrowIcon = new L.Icon({
        iconUrl: arrowImage,  // Usa la imagen importada
        iconSize: [32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32]
    });

    const getCoordinatesFromAddress = async (address) => {
        console.log('Dirección proporcionada: ', address);
        const simplifiedAddress = address.replace('#', '');
        const geocodeUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(simplifiedAddress)}`;

        try {
            const response = await fetch(geocodeUrl);
            if (!response.ok) {
                console.error('Error en la respuesta de la API:', response.statusText);
                return;
            }
            const data = await response.json();
            if (data && data.length > 0) {
                const lat = parseFloat(data[0].lat);
                const lon = parseFloat(data[0].lon);
                if (!isNaN(lat) && !isNaN(lon)) {
                    setLocationCoordinates([lat, lon]);
                } else {
                    console.error('Coordenadas inválidas: ', lat, lon);
                }
            } else {
                console.log('No se encontraron resultados para la dirección proporcionada.');
            }
        } catch (error) {
            console.error("Error al obtener las coordenadas desde la API:", error);
        }
    };

    const MapUpdater = ({ locationCoordinates }) => {
        const map = useMap();
        useEffect(() => {
            map.setView(locationCoordinates);
        }, [locationCoordinates, map]);
        return null;
    };

    async function postFormContact() {
        try {
            const dataPost = {
                data: {
                    nombre_completo: first_name,
                    apellidos: last_name,
                    correo: email,
                    telefono: `${prefixNumber} ${phone}`,
                    mensaje: message
                }
            };

            const response = await fetch(urlPostContacts, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataPost)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log('Success:', data);

            // Clear form after successful submission
            setFirst_name('');
            setLast_name('');
            setEmail('');
            setPhone('');
            setMessage('');

            alert('Form submitted successfully!');
        } catch (error) {
            console.error('Error:', error);
            alert('Failed to submit form. Please try again.');
        }
    }

    function headleFirst_name(e) {
        setFirst_name(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleLast_name(e) {
        setLast_name(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleEmail(e) {
        setEmail(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headlePrefix(e) {
        setPrefixNumber(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headlePhone(e) {
        setPhone(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleMessage(e) {
        setMessage(e.target.value); // Para un input tipo texto, usa `value`
    }

    return (
        <div className='mainContainerContact'>
            <div className="mapBackgroundContact">
                <MapContainer
                    center={locationCoordinates}
                    zoom={25}
                    style={{ height: '100%', width: '100%' }}
                    zoomControl={false}  // Deshabilita los controles de zoom
                    dragging={false}     // Deshabilita el arrastre del mapa
                    doubleClickZoom={false} // Deshabilita el zoom con doble click
                    scrollWheelZoom={false} // Deshabilita el zoom con la rueda del mouse
                    touchZoom={false}    // Deshabilita el zoom táctil
                    keyboard={false}     // Deshabilita el control con teclado
                    boxZoom={false}      // Deshabilita el zoom con box
                    tap={false}          // Deshabilita interacciones táctiles
                    attributionControl={false} // Opcional: elimina la atribución
                >
                    <MapUpdater locationCoordinates={locationCoordinates} />
                    <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <Marker position={locationCoordinates} icon={arrowIcon}>
                        <Popup>Oficinas Lomb Pan De Avacer<br />Barranquilla</Popup>
                    </Marker>
                </MapContainer>
            </div>
            <div className='dataAndFormContainer' style={{ backgroundImage: `url(${lightBg})` }}>
                <div className='dataContainer'>
                    <div className='dataInfo'>
                        <p className={`titleContactUsContact `} >{data.length > 0 && data[0].titulo ? data[0].titulo : "..."}</p>
                        <p className={`textContactUsContact `}  >{data.length > 0 && data[0].introduccion ? data[0].introduccion : "..."}</p>
                        {dataInformation.length > 0 && (
                            <>
                                <p className={`textContactUsContact `} >{dataInformation[0]?.correo || "..."}</p>
                                <p className={`textContactUsContact `} >{dataInformation[0]?.telefono || "..."}</p>
                                <p className={`textContactUsContact `} >Sede panamá: {dataInformation[0]?.correo || "..."}</p>
                                <p className={`textContactUsContact `} >Fabrica en colombia : {dataInformation[0]?.Fabrica || "..."}</p>
                                <div className={`textContactUsContact `}>NIT: {dataInformation[0]?.NIT || "..."}</div>
                            </>
                        )}
                        <div className='socialNetworksArticuleContainerContact'>
                            <p className={`fallowContactUs `}  >Follow me on:</p>
                            <div className='imgSocialNetworkArticleHome'>
                                {dataInformation.length > 0 && dataInformation[0]?.Facebook_url && (
                                    <a href={dataInformation[0].Facebook_url}>
                                        <img src={facebook} alt='facebook' className='socialNetworksArticuleAbout' />
                                    </a>
                                )}
                                {dataInformation.length > 0 && dataInformation[0]?.x_url && (
                                    <a href={dataInformation[0].x_url}>
                                        <img src={x} alt='x' className='socialNetworksArticuleAbout' />
                                    </a>
                                )}
                                {dataInformation.length > 0 && dataInformation[0]?.instagram_url && (
                                    <a href={dataInformation[0].instagram_url}>
                                        <img src={instagram} alt='instagram' className='socialNetworksArticuleAbout' />
                                    </a>
                                )}
                                {dataInformation.length > 0 && dataInformation[0]?.linkeding_url && (
                                    <a href={dataInformation[0].linkeding_url}>
                                        <img src={linkeding} alt='linkeding' className='socialNetworksFooter optionsSocialNetworksFooter' />
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='formContainer'>
                    <div className={`cardFormContact `} >
                        <div className='titleFormContainerContact'>
                            <p className={`titleFormContact `} >{data.length > 0 && data[0].titulo_de_la_card ? data[0].titulo_de_la_card : "..."}</p>
                            <p className={`subTitleFormContact `} >{data.length > 0 && data[0].introduccion_de_la_card ? data[0].introduccion_de_la_card : "..."}</p>
                        </div>
                        <div className='fullNameContainerContact'>
                            <input type='text' placeholder='Nombre Completo' className='fullNameContact' value={first_name} onChange={headleFirst_name} />
                            <input type='text' placeholder='Apellidos' className='fullNameContact' value={last_name} onChange={headleLast_name} />
                        </div>
                        <input type='text' placeholder='Tu correo' className='emailContact' value={email} onChange={headleEmail} />

                        <div className='phoneContainerContact'>
                            <select name="internationalPrefix" id="internationalPrefix" className='prefixContact' value={prefixNumber} onChange={headlePrefix} >
                                {countryCodes.map((code, index) => (
                                    <option key={index} value={code} className='prefixContact' >
                                        {code}
                                    </option>
                                ))}
                            </select>
                            <input type='text' placeholder='Numero de telefono' className='phoneNumber' value={phone} onChange={headlePhone} />
                        </div>
                        <textarea placeholder='¿Cómo podemos ayudar?' className='helpContact' value={message} onChange={headleMessage} />
                        <div className='buttonSubmitContact' onClick={postFormContact}>
                            <p className='submitContact'>Enviar</p>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Contact
